import { render } from "./DocumentUpload.vue?vue&type=template&id=44bf84c4&scoped=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&lang=js"

import "./DocumentUpload.vue?vue&type=style&index=0&id=44bf84c4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bf84c4"]])

export default __exports__